module.exports = "# 平台简介\n有量开放平台是为有量商家、服务商、合作伙伴提供工具服务业务接入的基础设置服务，有效的提高商家的运营消息和服务能力。\n\n## 供应商服务\n我们提供的API将逐步覆盖有量的各个核心业务流程，基于这些内容可为供应商提供各类应用，解决商品管理、订单管理、分销商管理、数据分析等方面的问题。\n## 分销商服务\n暂未开放\n\n如果您有任何建议可直接联系我们"


/*****************
 ** WEBPACK FOOTER
 ** ./app/data/guide/intro.md
 ** module id = 591
 ** module chunks = 1
 **/